// ACTION CREATOR SET_ADD_TO_HISTORY
export const SET_ADD_TO_HISTORY = 'SET_ADD_TO_HISTORY';

// ACTION CREATOR setAddToHistory
export const setAddToHistory = (value) => ({
  type: SET_ADD_TO_HISTORY,
  value,
});

// ACTION CREATOR SET_OPEN_MODAL_EXPORT_QUERY
export const SET_OPEN_MODAL_EXPORT_QUERY = 'SET_OPEN_MODAL_EXPORT_QUERY';

// ACTION CREATOR setOpenModalExportQuery
export const setOpenModalExportQuery = (value) => ({
  type: SET_OPEN_MODAL_EXPORT_QUERY,
  value,
});

// ACTION CREATOR SET_BTN_EXPORT
export const SET_BTN_EXPORT = 'SET_BTN_EXPORT';

// ACTION CREATOR setBtnExport
export const setBtnExport = (value) => ({
  type: SET_BTN_EXPORT,
  value,
});

// ACTION CREATOR SET_FILE_NO_DATA
export const SET_FILE_NO_DATA = 'SET_FILE_NO_DATA';

// ACTION CREATOR setFileNoData
export const setFileNoData = (value) => ({
  type: SET_FILE_NO_DATA,
  value,
});
